import TmaisUsersList from "../tabs/users/List";

export const defaultTabs = () => [
  {
    label: 'Usuários',
    value: '',
    body: <TmaisUsersList />,
  },
]
